module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1100.111aad55.svg";